import { render, staticRenderFns } from "./newPostGM.vue?vue&type=template&id=65d972c0&"
import script from "./newPostGM.vue?vue&type=script&lang=js&"
export * from "./newPostGM.vue?vue&type=script&lang=js&"
import style0 from "./newPostGM.vue?vue&type=style&index=0&id=65d972c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports